import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthleteGLMLinkStatus, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

import { athleteGLMStatusKey } from './useAthleteGLMStatus';

/**
 * Re-attempt linking a broken/unlinked athlete (mirror of the outbound ensure_link).
 * On success invalidates the athlete detail + athlete list + GLM status caches.
 */
export default function useRetryAthleteGLMLink(): UseMutationResult<
  AxiosResponse<AthleteGLMLinkStatus>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  return useMutation(
    (athleteId: string) => client.post<AthleteGLMLinkStatus>(`athletes/${athleteId}/glm/retry/`),
    {
      onSuccess: (_data, athleteId) => {
        queryClient.invalidateQueries(athleteGLMStatusKey(athleteId));
        queryClient.invalidateQueries('athletes');
      },
    },
  );
}
